export default "__VITE_ASSET__fqxqO2a6__"